import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "AI & Data",
      description: "We design efficient data pipelines for seamless analysis, unlocking valuable insights with advanced analytics and business intelligence. Our solutions ensure secure and accessible data management while automating processes and decisions with AI. We leverage generative AI for content creation and use blockchain to enable secure transactions. Streamline machine learning model deployment with MLOps and enhance customer service through intelligent chatbots",
      icon: "fas fa-brain",
      features: [
        "Data Engineering",
        "Analytics & BI", 
        "AI Development",
        "Gen AI Solutions",
        "Blockchain",
        "MLOps"
      ]
    },
    {
      id: 2,
      title: "Services", 
      description: "We provide team augmentation, mobile app development for Android, iOS, and cross-platform, and responsive web solutions. Our IT consulting optimizes strategies, while cloud services ensure scalability. We specialize in game development, UI/UX design, DevOps, and offer QA & testing for quality performance. Our support & maintenance services keep applications running smoothly, and we create immersive experiences with extended reality technologies.",
      icon: "fas fa-cogs",
      features: [
        "Team Augmentation",
        "Mobile App Development",
        "IT Consulting", 
        "Cloud Services",
        "Game Development",
        "DevOps & QA"
      ]
    },
    {
      id: 3,
      title: "Engineering",
      description: "We specialize in embedded systems, IoT development, and industrial IoT solutions. Our expertise also extends to low-code and MVP development, software engineering, and intelligent automation. We serve industries including automotive, aerospace, medical equipment, and consumer electronics. Additionally, we offer Embedded Foundation (EF™) and System Design™ for advanced system design and integration",
      icon: "fas fa-microchip",
      features: [
        "Embedded Systems",
        "IoT Development",
        "MVP Development",
        "Intelligent Automation",
        "Automotive & Aerospace",
        "System Design™"
      ]
    }
  ];

  return (
    <section className="services section" id="services">
      <div className="container">
        <div className="section-header text-center">
          <h2>Our Services - Think Innovative</h2>
          <p>VIEW ALL SERVICES</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={service.id} className="service-card" data-aos="fade-up" data-aos-delay={index * 200}>
              <div className="service-number">
                0{service.id}
              </div>
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <button className="btn btn-outline">Learn More</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 